export default __webpack_public_path__ + "static/media/creditCardColor.1fe7d3d0.svg";